import { useCallback } from 'react';
import type { PriceHistoryTimelineRecordView } from './use-price-history-timeline';

export type PriceHistoryViewListingHandler = (addressPath: string, listingId: number) => void;

// Builds the navigation target for opening a historical listing page.
function getPriceHistoryNavigationTarget(
  record: PriceHistoryTimelineRecordView
): { addressPath: string; listingId: number } | null {
  if (!record.addressPath || record.id == null) return null;

  return {
    addressPath: record.addressPath,
    listingId: record.id,
  };
}

// Shared navigation hook for clickable price history rows.
export function usePriceHistoryRecordNavigation(
  record: PriceHistoryTimelineRecordView,
  onViewListingClick?: PriceHistoryViewListingHandler
) {
  const target = getPriceHistoryNavigationTarget(record);
  const isClickable = Boolean(target && onViewListingClick);
  const handleClick = useCallback(() => {
    if (!target || !onViewListingClick) return;
    onViewListingClick(target.addressPath, target.listingId);
  }, [onViewListingClick, target]);

  return { isClickable, handleClick };
}
